import styled from "styled-components"

export const Form = styled.form`
	.md-form:first-child {
		margin-top: 0;
	}
`
